export default __webpack_public_path__ + "static/media/Profile.afb7ce70.jpg";